import { Component, Input } from '@angular/core';
import { NavParams } from '@ionic/angular';

import { MessageConstant } from '../../Constant';

import { AuthService } from '../../service/auth.service';
import { EventService } from '../../service/event.service';

@Component({
    selector: 'app-rename-modal',
    templateUrl: './rename-modal.page.html',
    styleUrls: ['./rename-modal.page.scss'],
})
export class RenameModalPage
{
    private isdisabled = true;
    private file: any;
    private name = "";
    private file_name_ext = "";
    private error = "";

    constructor(
        private navParams: NavParams,
        private auth: AuthService,
        private event: EventService
    )
    {
    }

    async ngOnInit()
    {
        this.event.modal_subject.next({key: "modalSubscribe", id: 'rename-modal', value: null});
        this.file = this.navParams.data.file;
        const full_name = this.file.file_name;

        if (this.file.file_flg == 1) {
            const exts = full_name.split(".");
            this.file_name_ext = exts.pop();
            this.name = (exts.length > 1 ? exts.join(".") : exts[0]);
        } else {
            this.name = full_name;
        }
    }

    async renameSend()
    {
        if (this.isdisabled === true) {
            return;
        }

        let ret_name = "";

        if (this.file.file_flg == 1) {
            ret_name = this.name+'.'+this.file_name_ext;
        } else {
            ret_name = this.name;
        }

        this.event.modal_subject.next({key: "closeModal", id: 'rename-modal', value: { name: ret_name }});
    }

    async renameOnChange(event)
    {
        this.name = event.target.value;

        if (this.auth.empty(this.name)) {
            this.isdisabled = true;
            return;
        } else {
            this.isdisabled = false;
        }

        if (!this.auth.isSafeCharactor(event.target.value, this.file.file_flg)) {
            this.isdisabled = true;
            this.error = MessageConstant.FORBIDDEN_CHAR_ERR;
            return;
        }

        this.error = "";
    }

    async renameClose()
    {
        this.event.modal_subject.next({key: "closeModal", id: 'rename-modal', value: null});
    }
}
